import React from "react";
import { useNavigate } from "react-router-dom";
import "./BirdGrid.css";

// Import your bird images
import parrotImage from "../images/parrot.jpeg";
import swanImage from "../images/swan.jpeg";
import eagleImage from "../images/eagle.jpeg";
import peacockImage from "../images/peacock.jpg";
import owlImage from "../images/owl.jpeg";
import flamingoImage from "../images/flamingo.jpg";

function BirdGrid() {
  const navigate = useNavigate();

  // ✅ Bird list with navigation paths
  const birds = [
    { name: "Parrot", image: parrotImage, path: "/parrot" },
    { name: "Swan", image: swanImage, path: "/swan" },
    { name: "Eagle", image: eagleImage, path: "/eagle" },
    { name: "Peacock", image: peacockImage, path: "/peacock" },
    { name: "Owl", image: owlImage, path: "/owl" },
    { name: "Flamingo", image: flamingoImage, path: "/flamingo" },
  ];

  return (
    <div className="bird-grid">
      {birds.map((bird, index) => (
        <div key={index} className="bird-card">
          <img src={bird.image} alt={bird.name} />
          <h3>{bird.name}</h3>
          <button onClick={() => navigate(bird.path)}>Learn More</button>
        </div>
      ))}
    </div>
  );
}

export default BirdGrid;


